import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import TechImagePanel from '@/components/feature/TechImagePanel';
import Hero from './components/Hero';
import Positioning from './components/Positioning';
import TotalArchitecture from './components/TotalArchitecture';
import CoreTech from './components/CoreTech';
import FourDiagrams from './components/FourDiagrams';
import PolicyMap from './components/PolicyMap';
import Directory from './components/Directory';

export default function Jiuchou() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <SEO
        title="九畴云铺 | 乡村数字经济操作系统"
        description="九畴云铺是华辉数智打造的乡村数字经济操作系统，以TOMA智能体、数字货架、ePin数据底座、数字消费与智能清分构建可复制的县域数字商业基础设施。"
        keywords="九畴云铺,乡村数字经济操作系统,数字货架,TOMA智能体,ePin,智能清分,县域商业"
        path="/jiuchou"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: '九畴云铺',
          description: '乡村数字经济操作系统',
          about: '乡村数字经济操作系统',
        }}
      />
      <main>
        <Hero />
        <Positioning />
        <TotalArchitecture />
        <CoreTech />
        <FourDiagrams />
        <TechImagePanel
          eyebrow="价值网络"
          title="消费 → 数据 → 产业 → 再增长"
          desc="九畴云铺的价值网络不只是一次交易，而是让每一次消费都沉淀为数据、反哺产业、驱动县域经济再增长。"
          chips={['七方共利', '数据回流', '产业协同', '再增长']}
          stats={[
            { value: '人·货·店·场', label: '连接' },
            { value: '数据 → AI', label: '智能层' },
            { value: '0# → N#', label: '复制扩张' },
          ]}
          imageUrl="https://readdy.ai/api/search-image?query=Abstract%20rural%20digital%20economy%20value%20network%20visualization%2C%20deep%20dark%20ink%20navy%20background%2C%20glowing%20emerald%20and%20gold%20constellation%20nodes%20interconnecting%20county%20shops%20and%20data%20streams%2C%20circular%20value%20loop%20of%20consumption%20to%20industry%20growth%2C%20futuristic%20ecosystem%2C%20minimal%20geometric%20composition%2C%20cinematic%20lighting%2C%20high%20detail&width=1600&height=900&seq=jiuchou-panel-value&orientation=landscape"
          imageAlt="九畴云铺 价值网络"
        />
        <PolicyMap />
        <Directory />
      </main>
      <Footer />
    </div>
  );
}